<template>
  <div>
    <v-row dense>
      <v-col cols="12" class="pa-1">
        <v-tabs vertical>
          <v-tab style="justify-content: start; min-width: 24px !important" class="pr-1">
            <v-icon left>description</v-icon>
            <span class="hidden-xs-only">Detalhes Pedido</span>
          </v-tab>
          <v-tab style="justify-content: start; min-width: 24px !important" class="pr-1">
            <v-icon left>mdi-cart</v-icon>
            <span class="hidden-xs-only">Produtos</span>
          </v-tab>
          <v-tab style="justify-content: start; min-width: 24px !important" class="pr-1">
            <v-icon left>mdi-map-marker</v-icon>
            <span class="hidden-xs-only">Local de Entrega</span>
          </v-tab>

          <v-tab-item :transition="false" :reverse-transition="false">
            <!-- detalhe pedido -->
            <v-row dense class="ml-2" style="border-left: 1px solid lightgrey">
              <v-col cols="12">

              <v-row dense class="pl-3 pr-1">
                <v-col cols="12" sm="3" class="pa-0 px-1">
                  <v-chip
                    color="lightgrey"
                    class="ma-2 mx-0"
                    label
                    style="width: 100%; display: grid"
                  >
                    <span>Número</span>
                    <v-spacer />
                    <span>
                      <b>{{pedido_cliente.id}}</b>
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="4" class="pa-0 px-1">
                  <v-chip class="ma-2 mx-0" label style="width: 100%; display: grid">
                    <span>Data</span>
                    <v-spacer />
                    <span>
                      <b>{{pedido_cliente.data | dataBR}}</b>
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="5" class="pa-0 px-1">
                  <v-chip class="ma-2 mx-0" label style="width: 100%; display: grid">
                    <span>Status</span>
                    <v-spacer />
                    <span>
                      <b>{{status_pedido}}</b>
                    </span>
                  </v-chip>
                </v-col>
              </v-row>

              <v-row dense class="pl-3 pr-1">
                <v-col cols="12" sm="6" class="pa-0 px-1">
                  <v-chip
                    color="lightgrey"
                    class="ma-2 mx-0"
                    label
                    style="width: 100%; display: grid"
                  >
                    <span>Comissão Percentual</span>
                    <v-spacer />
                    <span>
                      <b>{{pedido_cliente.comissao_percentual}} %</b>
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" class="pa-0 px-1">
                  <v-chip class="ma-2 mx-0" label style="width: 100%; display: grid">
                    <span>Comissão Valor</span>
                    <v-spacer />
                    <span>
                      <b>R$ {{pedido_cliente.comissao_valor| valorBR}}</b>
                    </span>
                  </v-chip>
                </v-col>
              </v-row>

              <v-row dense class="pl-3 pr-1">
                <v-col cols="12" sm="3" class="pa-0 px-1">
                  <v-chip class="ma-2 mx-0" label style="width: 100%; display: grid">
                    <span>Itens</span>
                    <v-spacer />
                    <span>
                      <b>{{produtos.length}}</b>
                    </span>
                  </v-chip>
                </v-col>

                <v-col cols="12" sm="4" class="pa-0 px-1">
                  <v-chip class="ma-2 mx-0" label style="width: 100%; display: grid">
                    <span>Quantidade Total</span>
                    <v-spacer />
                    <span>
                      <b>{{produtos.reduce((total, item) => total + item.quantidade, 0)}}</b>
                    </span>
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="5" class="pa-0 px-1">
                  <v-chip class="mt-2 pr-0" label style="width: 100%; display: grid">
                    <span>Valor Total</span>
                    <v-spacer />
                    <v-chip color="primary" label>
                      <h3>R$ {{pedido_cliente.valor | valorBR}}</h3>
                    </v-chip>
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          </v-tab-item>

          <v-tab-item
            :transition="false"
            :reverse-transition="false"
            class="ml-2 pl-3"
            style="border-left: 1px solid lightgrey"
          >
            <!-- produtos -->
            <v-card v-for="(item, index) in produtos" :key="index" class="mb-2 pr-2">
              <div style="display: flex; flex-direction: row">
                <v-avatar class="ma-3" size="68" tile>
                  <v-img :src="item.fotos[0]" style="border-radius: 4px; border: 1px solid #eee">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <div style="overflow: hidden">
                  <v-card-subtitle
                    class="headline pt-2 pb-0 pl-0 text--primary"
                    style="text-overflow: ellipsis; overflow: hidden; display: block; font-size: 1.2rem !important"
                  >{{item.descricao}}</v-card-subtitle>
                  <v-card-subtitle
                    class="py-0 pl-0"
                    style="font-size: 0.8rem; font-weight: 300"
                  >Código - {{item.id}}</v-card-subtitle>

                  <v-card-subtitle class="pb-2 pt-1 pl-0">
                    <span>{{item.quantidade}}</span> x
                    <span>R$ {{item.valor | valorBR}}</span>
                    <span
                      class="hidden-xs-only"
                      style="background-color: dimgrey; color: white; border-radius: 4px; padding: 0px 4px; margin-left: 6px"
                    >R$ {{item.valor * item.quantidade | valorBR}}</span>
                  </v-card-subtitle>
                </div>
              </div>
            </v-card>
          </v-tab-item>

          <v-tab-item :transition="false" :reverse-transition="false">
            <!-- entrega -->
            <v-row dense class="ml-2" style="border-left: 1px solid lightgrey">
              <v-row dense class="pt-0 ml-2">
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Nome Fantasia"
                    v-model="pedido_cliente.cliente_loja.nome_fantasia"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Razão Social"
                    v-model="pedido_cliente.cliente_loja.razao_social"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="pt-0 ml-2">
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="CNPJ"
                    v-model="pedido_cliente.cliente_loja.cnpj"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Rua"
                    v-model="pedido_cliente.cliente_loja.endereco.rua"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="pt-0 ml-2">
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Número"
                    v-model="pedido_cliente.cliente_loja.endereco.numero"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Bairro"
                    v-model="pedido_cliente.cliente_loja.endereco.bairro"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="CEP"
                    v-model="pedido_cliente.cliente_loja.endereco.cep"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="pt-0 ml-2">
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Local"
                    v-model="pedido_cliente.cliente_loja.endereco.local"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Celular"
                    v-model="pedido_cliente.cliente_loja.endereco.celular"
                    hide-details
                    background-color="#f8f8f8"
                    filled
                    placeholder=" "
                    persistent-placeholder readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

    <v-layout v-show="loading" class="justify-center align-center my-5">
      <v-progress-circular indeterminate size="50" width="3" color="primary"></v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import ServicePedidos from "@/services/pedidos.js";

export default {
  name: "PedidosClientesDetalhes",
  props: {
    pedido_cliente_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      pedido_cliente: {
        id: "",
        data: "",
        valor: 0,
        status: 0,
        forma_pagamento: "",
        cliente_loja: {
          nome_fantasia: "",
          cnpj: "",
          endereco: {
            rua: "",
            numero: "",
            complemento: "",
            bairro: "",
            local: "",
            cep: "",
          },
        },
        representante: {
          nome_fantasia: "",
          banco: "",
          agencia: "",
          conta: "",
          conta_tipo: "",
        },
      },
      produtos: [],
    };
  },
  mounted() {
    this.carregarInfoPedidoCliente();
  },
  methods: {
    async carregarInfoPedidoCliente() {
      try {
        this.loading = true;
        let pedido_response = await ServicePedidos.detalharPedidoCliente(
          this.pedido_cliente_id
        );
        this.pedido_cliente = pedido_response.data.pedido_cliente;
        this.produtos = pedido_response.data.produtos;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    status_pedido() {
      switch (this.pedido_cliente.status) {
        case 0:
          return "Em aberto";
        case 1:
          return "Revisado";
        case 2:
          return "Em expedição";
        case 3:
          return "Fechado";
        case 4:
          return "Enviado";
      }
    },
  },
  watch: {
    pedido_cliente_id: {
      handler: function (val, oldVal) {
        this.carregarInfoPedidoCliente();
      },
    },
  },
};
</script>

<style>
</style>